import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200120SuSaSkA4Status: 'idle',
    startProcess200120SuSaSkA4Error: undefined as any,
    loadUserParamsProcess200120SuSaSkA4Status: 'idle',
    loadUserParamsProcess200120SuSaSkA4Error: undefined as any,

    process200120SuSaSkA4List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200120SuSaSkA4 = createAsyncThunk('process200120SuSaSkA4Slice/startProcess200120SuSaSkA4', async ({ process200120SuSaSkA4 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200120SuSaSkA4/`,
        prepareData(process200120SuSaSkA4),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200120SuSaSkA4Status } = getState().process200120SuSaSkA4Slice
        return startProcess200120SuSaSkA4Status !== 'pending'
    }
})

export const loadUserParamsProcess200120SuSaSkA4 = createAsyncThunk('process200120SuSaSkA4Slice/loadUserParamsProcess200120SuSaSkA4', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200120SuSaSkA4/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200120SuSaSkA4Status } = getState().process200120SuSaSkA4Slice
        return loadUserParamsProcess200120SuSaSkA4Status !== 'pending'
    }
})

const Process200120SuSaSkA4Slice = createSlice({
    name: 'process200120SuSaSkA4Slice',
    initialState,
    reducers: {
        resetstartProcess200120SuSaSkA4: (state) => {
            state.job = undefined
            state.startProcess200120SuSaSkA4Error = undefined
        },
        resetstartProcess200120SuSaSkA4Error: (state) => {
            state.startProcess200120SuSaSkA4Error = undefined
        },
        resetloadUserParamsProcess200120SuSaSkA4: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200120SuSaSkA4Error = undefined
        },
        resetloadUserParamsProcess200120SuSaSkA4Error: (state) => {
            state.loadUserParamsProcess200120SuSaSkA4Error = undefined
        },
        removeFromProcess200120SuSaSkA4ListById: (state, action) => {
            state.process200120SuSaSkA4List = state.process200120SuSaSkA4List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200120SuSaSkA4ListByIds: (state, action) => {
            state.process200120SuSaSkA4List = state.process200120SuSaSkA4List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200120SuSaSkA4List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200120SuSaSkA4Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200120SuSaSkA4List = []
            state.startProcess200120SuSaSkA4Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200120SuSaSkA4.pending, (state) => {
            state.startProcess200120SuSaSkA4Status = 'pending'
            state.startProcess200120SuSaSkA4Error = undefined
        })
        builder.addCase(startProcess200120SuSaSkA4.fulfilled, (state, action) => {
            state.startProcess200120SuSaSkA4Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200120SuSaSkA4.rejected, (state, action) => {
            state.startProcess200120SuSaSkA4Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200120SuSaSkA4Error = action.error.message
            } else {
                state.startProcess200120SuSaSkA4Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200120SuSaSkA4.pending, (state) => {
            state.loadUserParamsProcess200120SuSaSkA4Status = 'pending'
            state.loadUserParamsProcess200120SuSaSkA4Error = undefined
        })
        builder.addCase(loadUserParamsProcess200120SuSaSkA4.fulfilled, (state, action) => {
            state.loadUserParamsProcess200120SuSaSkA4Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200120SuSaSkA4.rejected, (state, action) => {
            state.loadUserParamsProcess200120SuSaSkA4Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200120SuSaSkA4Error = action.error.message
            } else {
                state.loadUserParamsProcess200120SuSaSkA4Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200120SuSaSkA4,
    resetstartProcess200120SuSaSkA4Error,
    resetloadUserParamsProcess200120SuSaSkA4,
    resetloadUserParamsProcess200120SuSaSkA4Error,
    removeFromProcess200120SuSaSkA4ListById,
    removeFromProcess200120SuSaSkA4ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200120SuSaSkA4Slice.actions
export default Process200120SuSaSkA4Slice.reducer
